import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRound, Truck, ClipboardPen, ChevronRight } from 'lucide-react';

const items = [
  { label: 'Sign in as User', icon: UserRound, to: '/signin-user', accent: 'text-emerald-600 bg-emerald-50' },
  { label: 'Sign in as Mover', icon: Truck, to: '/signin-mover', accent: 'text-primary bg-orange-50' },
  { label: 'Register as Mover', icon: ClipboardPen, to: '/register', accent: 'text-blue-600 bg-blue-50' },
];

const SignInDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const go = (to) => { onClose?.(); navigate(to); };

  return (
    <div className="absolute right-0 mt-2 w-52 origin-top-right rounded-xl border border-gray-100 bg-white shadow-[0_12px_32px_rgba(0,0,0,0.12)] ring-1 ring-black/5 z-40 overflow-hidden animate-fadeIn">
      <p className="px-3 pt-2.5 pb-1 text-[11px] font-semibold uppercase tracking-wider text-gray-400">Account</p>
      <div className="px-1.5 pb-1.5">
        {items.map(({ label, icon: Icon, to, accent }) => (
          <button
            key={to}
            onClick={() => go(to)}
            className="group flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left transition-colors duration-200 hover:bg-gray-50"
          >
            <span className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${accent}`}>
              <Icon className="h-4 w-4" />
            </span>
            <span className="flex-1 text-[13px] font-medium text-gray-700 group-hover:text-gray-900">{label}</span>
            <ChevronRight className="h-3.5 w-3.5 shrink-0 text-gray-300 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-gray-400" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SignInDropdown;
